import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  ButtonMenu,
  Button,
  Typography,
  Icon,
} from "@ann/web-components";
import {
  AutocompleteContainer,
  DescriptionContainer,
  InfoAlertContainer,
  InfoAlertContent,
  InfoAlertTextContainer,
} from "./Modal.styled";

const AddUserModalContent = observer(
  ({
    selectedUsers,
    selectedPermission,
    currentSelectionType,
    privileges,
    onUsersChange,
    onPermissionChange,
    onAddClick,
    usersList,
    onSearchUsers,
    loadingUsers,
  }) => {
    const navigate = useNavigate();

    const handleCreateNewUser = useCallback(() => {
      navigate("/v2/user-management");
    }, [navigate]);

    return (
      <>
        <DescriptionContainer>
          <Typography
            category="body"
            size="medium"
            weight="regular"
            color="body"
          >
            Select existing organization members to add to this department
          </Typography>
        </DescriptionContainer>
        <InfoAlertContainer>
          <InfoAlertContent>
            <InfoAlertTextContainer>
              <Icon name="info" size={20} color="info" />
              <Typography
                category="body"
                size="medium"
                weight="regular"
                color="body"
              >
                Can't find the user you're looking for? Create a new user
                account.
              </Typography>
            </InfoAlertTextContainer>
            <Button
              label="Create New User"
              size="medium"
              type="primary"
              iconLeft="personAdd"
              onClick={handleCreateNewUser}
            />
          </InfoAlertContent>
        </InfoAlertContainer>
        <AutocompleteContainer>
          <Autocomplete
            multiple={true}
            maxTagsMode="dynamic"
            onSelectionChange={onUsersChange}
            onSearch={onSearchUsers}
            onSuggestionSelect={() => {}}
            placeholder={loadingUsers ? "Loading users..." : "Search team members..."}
            selectedValues={selectedUsers}
            showInitialName
            suggestions={usersList || []}
            valueKey="user_uuid"
            labelKey="full_name"
          />
          <ButtonMenu
            iconPosition="right"
            label={selectedPermission || "Assign Role"}
            menuPosition="bottom"
            onChange={onPermissionChange}
            size="medium"
            type="secondary"
            width="auto"
          >
            <ButtonMenu.Menu>
              {privileges[
                currentSelectionType === "folder"
                  ? "folderPrivileges"
                  : "documentPrivileges"
              ].map((privilege) => (
                <ButtonMenu.Item
                  key={privilege.entityPrivilegeUuid}
                  label={privilege.privilegeName}
                  value={privilege.privilegeName}
                >
                  {privilege.privilegeName}
                </ButtonMenu.Item>
              )) || []}
            </ButtonMenu.Menu>
          </ButtonMenu>
          <Button
            label="Add"
            size="medium"
            onClick={onAddClick}
            disabled={selectedUsers.length === 0 || !selectedPermission}
          />
        </AutocompleteContainer>
      </>
    );
  }
);

export default AddUserModalContent;
